<div class="w-full h-full flex oveflow-auto" (window:resize)="onResize()">
  <div #sidebar>
    <ng-container *ngIf="settings?.positionMenuNav === 'left'">
      <app-navigation [expanded]="expanded" (manualToggle)="manualToggle()"></app-navigation>
    </ng-container>
  </div>
  <div id="center">
    <div id="header" #header>
      <ng-container
        *ngIf="settings?.positionInfoNav === 'top' && settings?.hiddenInfoNav === false">
        <app-header></app-header>
      </ng-container>
      <ng-container *ngIf="settings?.positionMenuNav === 'top'">
        <app-sidebar-top [expanded]="expanded"></app-sidebar-top>
      </ng-container>
    </div>
    <div id="content" [style.height.px]="heightContent" #content>
      <!-- <div *ngIf="settings?.positionMenuNav === 'left'" class="option" [style.width.px]="widthTabs" #menuOption>
        <div class="menu-option">
          <app-menu-option [trigger]="'hover'" [tooltipTrigger]="'null'"></app-menu-option>
        </div>
      </div> -->
      <nz-tabset 
        [nzSize]="'large'" 
        [(nzSelectedIndex)]="tabService.selectedIndex"
        nzType="editable-card" 
        (nzClose)="closeTab($event)" 
        (nzSelectChange)="setSelectedIndex($event)"
        nzTabPosition="top" 
        nzHideAdd [ngClass]="{'tab': settings?.positionMenuNav === 'left'}"
        (click)="checkForceRender()" 
        [nzTabBarExtraContent]="extraCloseAllTabTemplate"
        [style.width.px]="widthTabs"
        class="tabs-outside"
        >
        <nz-tab 
          [nzForceRender]="true" 
          *ngFor="let tab of tabs; let i = index" 
          [nzTitle]="tab.title" 
          [nzClosable]="i > 0"
          >
            <app-tab-content [tab]="tab"></app-tab-content>
        </nz-tab>
      </nz-tabset>
      <ng-template #extraCloseAllTabTemplate>
        <i class="closeAllTab" nz-icon nzType="close" nzTheme="outline" nzTooltipTitle="Đóng toàn bộ thẻ"
          nzTooltipPlacement="left" nz-tooltip (click)="closeAllTab()"></i>
      </ng-template>
      <!-- <router-outlet></router-outlet> -->
    </div>
  </div>
  <ng-container
    *ngIf="settings?.positionInfoNav === 'right' && settings?.hiddenInfoNav === false">
    <app-navbar-right *ngIf="isShowNavRight" (changeShowNav)="showNavBarRight()"></app-navbar-right>
    <button 
      class="flex items-center justify-center mr-3 fixed"
      nzType="primary" style="top: 10px; right: 10px"
      nz-button nzTooltipTitle="Hiển thị" 
      nzTooltipPlacement="bottom" 
      nz-tooltip 
      *ngIf="!isShowNavRight"
      (click)="showNavBarRight()">
        <i 
          nz-icon 
          nzShape="circle" 
          nzType="caret-left"
          nzTheme="outline"
          >
        </i>
    </button>
  </ng-container>
</div>
<svg-definitions></svg-definitions>
